var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.739 33.955a.462.462 0 0 1-.295-.104.527.527 0 0 1-.098-.312l-.426-15.123c0-.115.033-.208.098-.277a.397.397 0 0 1 .295-.139h3.833c.109 0 .196.046.262.139.087.07.13.162.13.277l-.49 15.123c0 .116-.044.22-.132.312a.343.343 0 0 1-.262.104H28.74zm1.277 8.29c-.742 0-1.364-.255-1.867-.763-.48-.532-.72-1.191-.72-1.977 0-.81.24-1.469.72-1.977.48-.509 1.103-.763 1.867-.763.765 0 1.376.254 1.835.763.48.508.72 1.168.72 1.977 0 .786-.24 1.445-.72 1.977-.48.508-1.092.763-1.835.763z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTip);
export default __webpack_public_path__ + "static/media/icon-tip.772c33cc6242acf09fefbc038e0cef1e.svg";
export { ForwardRef as ReactComponent };